import {
    BasePageBuilderAction,
    Initiator,
    MessageHandler,
    PageBuilderMessageParams,
    UNKNOWN_ACTION,
} from './constants';

class PageBuilderMessageHandler {
    private readonly baseContext: object;

    private readonly handlers: MessageHandler[];

    public constructor({ baseContext, handlers }: PageBuilderMessageParams) {
        this.baseContext = baseContext;
        this.handlers = handlers;
        this.buildMessageHandler();
    }

    private pageBuilderMessage = (event: MessageEvent): BasePageBuilderAction => {
        try {
            const data = JSON.parse(event.data);
            if (data.initiator === Initiator.PageBuilder) {
                return data as BasePageBuilderAction;
            }
        } catch {
            // We can safely skip messages which we cannot parse JSON from.
        }

        return {
            action: UNKNOWN_ACTION,
            initiator: Initiator.Unknown,
        };
    };

    private pageBuilderListener = (event: MessageEvent) => {
        const data = this.pageBuilderMessage(event);
        if (data.initiator === Initiator.Unknown) {
            return;
        }

        this.handlers.forEach(
            (handler: MessageHandler): void => {
                handler({ ...this.baseContext, data, event });
            },
        );
    };

    private buildMessageHandler = (): void => {
        window.addEventListener('message', this.pageBuilderListener, false);
    };
}

export default PageBuilderMessageHandler;
